import { Swiper, Navigation } from 'swiper';

function init(gallery) {
  const gallerySlider = gallery?.querySelector('.swiper');
  const nextEl = gallery.querySelector('.gallery__control--next');
  const prevEl = gallery.querySelector('.gallery__control--prev');

  if (gallerySlider) {
    const slides = gallerySlider.querySelectorAll('.swiper-slide');
    const slidesLength = slides.length;
    /* eslint-disable no-unused-vars */
    const swiper = new Swiper(gallerySlider, {
      slidesPerView: 1,
      loop: slidesLength > 1,
      modules: [Navigation],
      navigation: {
        nextEl,
        prevEl,
      },
    });
  }
}

window.document.addEventListener('DOMContentLoaded', () => {
  const blockClass = '.gallery';
  const blocks = document.querySelectorAll(blockClass);

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/gallery', ($block) => {
      init($block.find(blockClass)[0]);
    });
  } else {
    blocks.forEach(init);
  }

  const gallerySliderImages = document?.querySelectorAll('.gallery__image--slider');
  if (gallerySliderImages) {
    gallerySliderImages.forEach((img) => {
      const aspectRatio = img.width / img.height;

      if (aspectRatio > 1) {
        img.classList.add('horizontal');
      } else if (aspectRatio < 1) {
        img.classList.add('vertical');
      } else {
        img.classList.add('square');
      }
    });
  }
});
